import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=0a919ee2"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a919ee2')) {
      api.createRecord('0a919ee2', component.options)
    } else {
      api.reload('0a919ee2', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=0a919ee2", function () {
      api.rerender('0a919ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/Dialog.vue"
export default component.exports